import axios from "axios";
import { getMemberForSearchOnPanelLlogin, memberLogin } from "../../AllRoutes/ApiRoute";
import CommonLoader from "../../Utilities/CommonLoader";
import CommonToast from "../../Utilities/CommonToast";
import MemberPanelAuth from "../../Utilities/MemberPanelAuth";
import CommonAxios from "../../Utilities/CommonAxios";

// member login action
export const memberLoginAction = (payload) => (dispatch) => {
  const { data, loginBtnRef } = payload;

  // handle button disability
  CommonLoader.handleButtonDisability({
    button_ref: loginBtnRef,
    is_disabled: true,
  });

  // db operation
  axios
    .post(memberLogin, data)
    .then((res) => {
      // handle button disability
      CommonLoader.handleButtonDisability({
        button_ref: loginBtnRef,
        is_disabled: false,
      });

      if (res.data.status == true) {
        MemberPanelAuth.setSession({
          token: res?.data?.token,
          member_detail: res?.data?.member_detail,
        });
      } else {
        // login failed toast
        CommonToast.error(res.data?.message || "Login failed!");
      }
    })
    .catch((err) => {
      // handle button disability
      CommonLoader.handleButtonDisability({
        button_ref: loginBtnRef,
        is_disabled: false,
      });

      //   toast
      if (err?.response?.status == 401) {
        CommonToast.error(err?.response?.data?.message || "Login failed!");
      } else CommonToast.error("Login failed!");
    });
};


// member serch action

export const memberSearchAction = payload => dispatch => {
  // getting data from payload
  const {
    data,
    loginBtnRef,
    setSerchData
  } = payload

  // button loader handle
  CommonLoader.btn(loginBtnRef)

  // db operation
  CommonAxios.post(getMemberForSearchOnPanelLlogin, payload).then(res => {
    // button loader handle
    CommonLoader.btn(loginBtnRef)

    if (res.data.status == true) {
      // set print data
      setSerchData(res.data.data)


    } else {
      CommonToast.error("Some how sale failed!")
    }

  }).catch(err => {
    // button loader handle
    CommonLoader.btn(loginBtnRef)
  })
}